export const REQUEST_CALENDAR_CONTENT = "REQUEST_CALENDAR_CONTENT";
export const SET_CALENDAR_CONTENT = "SET_CALENDAR_CONTENT";
export const REVOKE_CALENDAR_CONTENT = "REVOKE_CALENDAR_CONTENT";
export const RESET_CALENDAR_CONTENT = "RESET_CALENDAR_CONTENT";

export const CHANGE_CALENDAR_MODALS = "CHANGE_CALENDAR_MODALS";

export const REQUEST_ADD_CALENDAR_EVENT = "REQUEST_ADD_CALENDAR_EVENT";
export const REVOKE_ADD_CALENDAR_EVENT = "REVOKE_ADD_CALENDAR_EVENT";
export const GRANT_ADD_CALENDAR_EVENT = "GRANT_ADD_CALENDAR_EVENT";
export const RESET_ADD_CALENDAR_EVENT = "RESET_ADD_CALENDAR_EVENT";

export const SET_ACTIVE_CALENDAR_DISPLAY = "SET_ACTIVE_CALENDAR_DISPLAY";
export const RESET_ACTIVE_CALENDAR_DISPLAY = "RESET_ACTIVE_CALENDAR_DISPLAY";

export const REQUEST_DELETE_CALENDAR_EVENT = "REQUEST_DELETE_CALENDAR_EVENT";
export const REVOKE_DELETE_CALENDAR_EVENT = "REVOKE_DELETE_CALENDAR_EVENT";
export const RESET_DELETE_CALENDAR_EVENT = "RESET_DELETE_CALENDAR_EVENT";
export const GRANT_DELETE_CALENDAR_EVENT = "GRANT_DELETE_CALENDAR_EVENT";

export const REQUEST_UPDATE_CALENDAR_EVENT = "REQUEST_UPDATE_CALENDAR_EVENT";
export const REVOKE_UPDATE_CALENDAR_EVENT = "REVOKE_UPDATE_CALENDAR_EVENT";
export const RESET_UPDATE_CALENDAR_EVENT = "RESET_UPDATE_CALENDAR_EVENT";
export const GRANT_UPDATE_CALENDAR_EVENT = "GRANT_UPDATE_CALENDAR_EVENT";
